unit UUsersMain;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, WEBLib.Grids, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.WebCtrls, XData.Web.Client;

type
  TfrmUsersMain = class(TForm)
    divUsersOuterContainer: THTMLDiv;
    divUsersMainContainer: THTMLDiv;
    divUsersControlContainer: THTMLDiv;
    tblUsers: TTableControl;
    btnNewUser: TButton;
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnNewUserClick(Sender: TObject);
    procedure tblUsersClickCell(Sender: TObject; ACol, ARow: Integer);
  private
    procedure NewUser;
    procedure ShowHeaders;
    [async] procedure GetUsers; async;
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  frmUsersMain: TfrmUsersMain;

implementation

uses
  UDatamodule, UUser, UHelper, UJSHelper, UResources, UErrorHandling;

{$R *.dfm}

procedure TfrmUsersMain.btnNewUserClick(Sender: TObject);
begin
  NewUser;
end;


procedure TfrmUsersMain.GetUsers;
var
  LResponse: TXDataClientResponse;
  UserArray : TJSArray;
  KundenArray : TJSArray;
  JSObject : TJsObject;
  User : TJSObject;
  I: Integer;
  Right : Integer;
  Idx : Integer;
  J: Integer;
  KundenStr : String;
begin
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUsers.GetUsersList',
        [UDM.UserID])
      );

    if LResponse.StatusCode = 200 then
    begin
      THelper.DebugODS('Received users list');
      JSObject := LResponse.ResultAsObject;
      UserArray := TJSArray(JSObject['value']);

      tblUsers.RowCount := UserArray.Length + 1;

      Idx := 0;

      for I := 0 to UserArray.Length - 1 do
      begin
        Idx := I + 1;

        User := TJsObject(UserArray.Elements[I]);
        THelper.DebugODS(String(User.Properties['UserName']));
        tblUsers.Cells[0, Idx] := String(User.Properties['UserID']);
        tblUsers.Cells[1, Idx] := String(User.Properties['EMail']);
        tblUsers.Cells[2, Idx] := String(User.Properties['Vorname']);
        tblUsers.Cells[3, Idx] := String(User.Properties['Nachname']);

        KundenStr := '';
        KundenArray := TJSArray(User.Properties['Kunden']);
        for J := 0 to KundenArray.Length - 1 do
        begin
          KundenStr := KundenStr + String(TJSObject(KundenArray.Elements[J]).Properties['Anzeigename']) + #13;
        end;

        if Length(KundenStr) > 0 then
        begin
          SetLength(KundenStr,  Length(KundenStr) - 1);
        end;

        tblUsers.Cells[4, Idx] := KundenStr;

        Right := StrToInt(String(User.Properties['LogisticRights']));
        if (Right = 1) then
          tblUsers.Cells[5, Idx] := 'Ja'
        else
          tblUsers.Cells[5, Idx] := 'Nein';

        Right := StrToInt(String(User.Properties['AdminRights']));
        if (Right = 1) then
          tblUsers.Cells[6, Idx] := 'Ja'
        else
          tblUsers.Cells[6, Idx] := 'Nein';
      end;

    end
    else
    begin
      MessageDlg('User list not received. Status: ' + IntToStr(LResponse.StatusCode), mtInformation, [mbOk]);
    end;
  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;


procedure TfrmUsersMain.NewUser;
var
  lform: TfrmUser;
begin
  if Assigned(lform) then
  begin
    lform.Close;
  end;
  lform := TfrmUser.CreateNew(divUsersOuterContainer.ElementID, nil);
end;


procedure TfrmUsersMain.ShowHeaders;
begin
  tblUsers.Cells[0,0] := 'ID';
  tblUsers.Cells[1,0] := 'EMail';
  tblUsers.Cells[2,0] := 'Vorname';
  tblUsers.Cells[3,0] := 'Nachname';
  tblUsers.Cells[4,0] := 'Kunden';
  tblUsers.Cells[5,0] := 'Logistik-Rechte';
  tblUsers.Cells[6,0] := 'Admin-Rechte';
end;


procedure TfrmUsersMain.tblUsersClickCell(Sender: TObject; ACol, ARow: Integer);
var
  lform: TfrmUser;
begin
  if Assigned(lform) then
  begin
    lform.Close;
  end;
  lform := TfrmUser.CreateNew(divUsersOuterContainer.ElementID, nil);
  lform.UserID := StrToInt(tblUsers.Cells[0, ARow]);
end;


procedure TfrmUsersMain.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Action := TCloseAction.caFree;
end;

procedure TfrmUsersMain.WebFormCreate(Sender: TObject);
begin
  ShowHeaders;
end;

procedure TfrmUsersMain.WebFormShow(Sender: TObject);
begin
{$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.OrdersMenuInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
    pas.UJSHelper.THTMLComponents.Translations();
  end;
{$ENDIF}
  GetUsers;
end;


procedure TfrmUsersMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divUsersOuterContainer := THTMLDiv.Create('wcIDUsersOuterContainer');
  divUsersMainContainer := THTMLDiv.Create('wcIDUsersMainContainer');
  divUsersControlContainer := THTMLDiv.Create('wcIDUsersControlContainer');
  btnNewUser := TButton.Create('wcIDNewUserBtn');
  tblUsers := TTableControl.Create('wcIDUsersTbl');

  divUsersOuterContainer.BeforeLoadDFMValues;
  divUsersMainContainer.BeforeLoadDFMValues;
  divUsersControlContainer.BeforeLoadDFMValues;
  btnNewUser.BeforeLoadDFMValues;
  tblUsers.BeforeLoadDFMValues;
  try
    Name := 'frmUsersMain';
    Width := 1098;
    Height := 866;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divUsersOuterContainer.SetParentComponent(Self);
    divUsersOuterContainer.Name := 'divUsersOuterContainer';
    divUsersOuterContainer.Left := 0;
    divUsersOuterContainer.Top := 0;
    divUsersOuterContainer.Width := 1098;
    divUsersOuterContainer.Height := 866;
    divUsersOuterContainer.HeightStyle := ssAuto;
    divUsersOuterContainer.WidthStyle := ssAuto;
    divUsersOuterContainer.Align := alClient;
    divUsersOuterContainer.ChildOrder := 2;
    divUsersOuterContainer.ElementPosition := epIgnore;
    divUsersOuterContainer.ElementFont := efCSS;
    divUsersOuterContainer.Role := '';
    divUsersMainContainer.SetParentComponent(divUsersOuterContainer);
    divUsersMainContainer.Name := 'divUsersMainContainer';
    divUsersMainContainer.Left := 0;
    divUsersMainContainer.Top := 0;
    divUsersMainContainer.Width := 1098;
    divUsersMainContainer.Height := 866;
    divUsersMainContainer.ElementClassName := 'wcCLMainContainer Container';
    divUsersMainContainer.HeightStyle := ssAuto;
    divUsersMainContainer.WidthStyle := ssAuto;
    divUsersMainContainer.Align := alClient;
    divUsersMainContainer.ElementPosition := epIgnore;
    divUsersMainContainer.ElementFont := efCSS;
    divUsersMainContainer.Role := '';
    divUsersControlContainer.SetParentComponent(divUsersMainContainer);
    divUsersControlContainer.Name := 'divUsersControlContainer';
    divUsersControlContainer.Left := 0;
    divUsersControlContainer.Top := 0;
    divUsersControlContainer.Width := 1098;
    divUsersControlContainer.Height := 121;
    divUsersControlContainer.ElementClassName := 'row wcCLUsersControlContainer';
    divUsersControlContainer.HeightStyle := ssAuto;
    divUsersControlContainer.WidthStyle := ssAuto;
    divUsersControlContainer.Align := alTop;
    divUsersControlContainer.ChildOrder := 1;
    divUsersControlContainer.ElementPosition := epIgnore;
    divUsersControlContainer.ElementFont := efCSS;
    divUsersControlContainer.Role := '';
    btnNewUser.SetParentComponent(divUsersControlContainer);
    btnNewUser.Name := 'btnNewUser';
    btnNewUser.Left := 881;
    btnNewUser.Top := 31;
    btnNewUser.Width := 145;
    btnNewUser.Height := 50;
    btnNewUser.Caption := 'Neuer Benutzer';
    btnNewUser.ElementClassName := 'btn btn-primary wcCLNewUserBtn';
    btnNewUser.ElementFont := efCSS;
    btnNewUser.ElementPosition := epIgnore;
    btnNewUser.Font.Charset := DEFAULT_CHARSET;
    btnNewUser.Font.Color := clWindowText;
    btnNewUser.Font.Height := -19;
    btnNewUser.Font.Name := 'Tahoma';
    btnNewUser.Font.Style := [];
    btnNewUser.HeightStyle := ssAuto;
    btnNewUser.HeightPercent := 100.000000000000000000;
    btnNewUser.ParentFont := False;
    btnNewUser.TabOrder := 9;
    btnNewUser.WidthStyle := ssAuto;
    btnNewUser.WidthPercent := 100.000000000000000000;
    SetEvent(btnNewUser, Self, 'OnClick', 'btnNewUserClick');
    tblUsers.SetParentComponent(divUsersMainContainer);
    tblUsers.Name := 'tblUsers';
    tblUsers.Left := 125;
    tblUsers.Top := 250;
    tblUsers.Width := 705;
    tblUsers.Height := 369;
    tblUsers.ElementClassName := 'display wcCLTableUsers';
    tblUsers.HeightStyle := ssAuto;
    tblUsers.WidthStyle := ssAuto;
    tblUsers.BorderColor := clSilver;
    tblUsers.ChildOrder := 1;
    tblUsers.ElementFont := efCSS;
    tblUsers.ElementHeaderClassName := 'thead-light';
    tblUsers.ElementPosition := epIgnore;
    tblUsers.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    tblUsers.Font.Charset := DEFAULT_CHARSET;
    tblUsers.Font.Color := clWindowText;
    tblUsers.Font.Height := -16;
    tblUsers.Font.Name := 'Tahoma';
    tblUsers.Font.Style := [];
    tblUsers.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    tblUsers.Footer.ButtonElementClassName := 'btn btn-light';
    tblUsers.Footer.DropDownElementClassName := 'form-control';
    tblUsers.Footer.InputElementClassName := 'form-control';
    tblUsers.Footer.LinkActiveElementClassName := 'link-primary';
    tblUsers.Footer.LinkElementClassName := 'link-secondary';
    tblUsers.Footer.ListElementClassName := 'pagination';
    tblUsers.Footer.ListItemElementClassName := 'page-item';
    tblUsers.Footer.ListLinkElementClassName := 'page-link';
    tblUsers.Header.ButtonActiveElementClassName := 'btn btn-primary';
    tblUsers.Header.ButtonElementClassName := 'btn btn-light';
    tblUsers.Header.DropDownElementClassName := 'form-control';
    tblUsers.Header.InputElementClassName := 'form-control';
    tblUsers.Header.LinkActiveElementClassName := 'link-primary';
    tblUsers.Header.LinkElementClassName := 'link-secondary';
    tblUsers.Header.ListElementClassName := 'pagination';
    tblUsers.Header.ListItemElementClassName := 'page-item';
    tblUsers.Header.ListLinkElementClassName := 'page-link';
    tblUsers.ParentFont := False;
    tblUsers.WordWrap := True;
    SetEvent(tblUsers, Self, 'OnClickCell', 'tblUsersClickCell');
    tblUsers.ColCount := 7;
  finally
    divUsersOuterContainer.AfterLoadDFMValues;
    divUsersMainContainer.AfterLoadDFMValues;
    divUsersControlContainer.AfterLoadDFMValues;
    btnNewUser.AfterLoadDFMValues;
    tblUsers.AfterLoadDFMValues;
  end;
end;

initialization

RegisterClass(TfrmUsersMain);

end.